import { useNavigate } from "react-router-dom"
import { api } from "../../../env"
import Input, { useTextInput, required, submitForm } from "../../../components/input"


export default function CreateCompany() {

    const navigate = useNavigate()

    const createForm = {
        name: useTextInput("Name", "label", [required]),
        description: useTextInput("Description", "description", [])
    }

    const onClose = () => navigate('..') 

    const handleCreate = () => {
        const companyInfo = submitForm(createForm)
        if (!companyInfo) return
        console.log(companyInfo)
        api.post('/companies', companyInfo)
            .then(res => {
                console.log(res.data)
                onClose()
            })
            .catch(err => {
                console.log("Creating compnay failed...")
                onClose()
            })
    }

    return(<div className="page-xl-centered standard-padding showing">
        <p className="section-title v-spacer-m">Create Company</p>
        <div className="card flex columns gap-xs">
            <Input state={createForm.name}/>
            <Input state={createForm.description}/>
            <div className="flex gap-xs justify-end">
                <button className="outline" onClick={onClose}>Cancel</button>
                <button className="solid-accent" onClick={handleCreate}>Create</button>
            </div>
        </div>
    </div>)
}